<template>
<div id="">
  <v-dialog v-model="$store.state.account.show_terms" max-width="600" persistent>
    <v-card>
      <v-card-title class="secondary white--text">
        <h5 v-if="$store.getters['account/type']==='user'">WhyBuy User Agreement</h5>
        <h5 v-if="$store.getters['account/type']==='business'">WhyBuy Business Agreement</h5>
        <v-spacer></v-spacer>
      </v-card-title>

      <v-card-text class="pt-4" style="max-height:350px;overflow-y:auto">
        <p v-html="$store.state.app.terms" v-if="$store.getters['account/type']==='user'"></p>
        <p v-html="$store.state.app.terms_business" v-if="$store.getters['account/type']==='business'"></p>
      </v-card-text>

      <v-card-actions class="grey lighten-3">
        <v-spacer></v-spacer>
        <v-btn text @click="$store.commit('account/logout')">Sign Out</v-btn>
        <v-btn color="primary" @click="accept" :loading="loading">I agree</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>
<script>
/*
function validateEmail(email) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

function validatePhone(v) {
  var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
  return re.test(String(v).toLowerCase());
}

*/

export default {
  name: "",
  created() {

  },
  data: () => ({
    loading: false
  }),
  computed: {

  },
  methods: {
    async accept() {
      this.loading = true
      await this.$store.dispatch('account/acceptTerms')
      this.loading = false
    }
  }
}
</script>


<style lang="scss" scoped>

</style>
